// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pending-approvals {
  margin-bottom: 32px;
}
.pending-approvals-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.pending-approvals-heading h2 {
  margin: 0 0 3px;
  font-size: 1.25rem;
}
.pending-approvals-heading p {
  margin: 0;
}
.pending-approvals-heading > span {
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 0.78rem;
}
.approval-list {
  display: grid;
  gap: 12px;
}
.approval-card {
  border: 1px solid var(--border-color, #d8d8d8);
  border-radius: var(--radius);
  padding: 16px;
  background: var(--card-background, #fff);
  color: var(--text-color, #111);
  box-shadow: var(--card-shadow, 0 2px 8px rgba(0, 0, 0, 0.04));
}
.approval-card-project {
  border-left: 4px solid #4f7cff;
}
.approval-card-chat {
  border-left: 4px solid #8b5cf6;
}
.approval-card-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.approval-card-head h3 {
  margin: 3px 0 0;
  font-size: 1rem;
}
.approval-card-head time {
  color: var(--secondary-text-color, #6b7280);
  font-size: 0.78rem;
  white-space: nowrap;
}
.approval-agent {
  color: var(--secondary-text-color, #6b7280);
  font-size: 0.78rem;
  font-weight: 600;
}
a.approval-agent {
  color: var(--secondary-text-color, #6b7280);
  text-decoration: none;
}
a.approval-agent:hover {
  text-decoration: underline;
}
.approval-requester {
  color: var(--secondary-text-color, #6b7280);
  font-size: 0.78rem;
}
.approval-on-behalf strong {
  color: var(--text-color, inherit);
  font-weight: 600;
}
.approval-unattended {
  font-style: italic;
}
a.approval-origin-link {
  color: var(--link-color, #3769d6);
  text-decoration: underline;
}
.approval-reason {
  margin: 13px 0;
  padding: 11px 12px;
  border-radius: var(--radius);
  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));
}
.approval-reason > span {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--secondary-text-color, #6b7280);
  font-weight: 700;
}
.approval-reason p {
  margin: 5px 0 0;
  white-space: pre-wrap;
}
.approval-invite-person {
  margin: 13px 0;
  padding: 11px 12px;
  border-radius: var(--radius);
  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));
}
.approval-invite-person > span {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--secondary-text-color, #6b7280);
  font-weight: 700;
}
.approval-invite-person p {
  margin: 5px 0 0;
  font-weight: 600;
}
.approval-inputs {
  display: grid;
  gap: 10px;
  margin: 12px 0;
}
.approval-inputs label,
.approval-note {
  display: grid;
  gap: 5px;
  font-size: 0.83rem;
  font-weight: 600;
}
.approval-inputs input,
.approval-note select,
.approval-note textarea {
  width: 100%;
  border: 1px solid var(--input-border, #ccc);
  border-radius: 7px;
  padding: 9px 10px;
  color: inherit;
  background: var(--background-color, transparent);
}
.approval-note textarea {
  min-height: 64px;
  resize: vertical;
}
.approval-note small {
  font-weight: 400;
  color: var(--secondary-text-color, #6b7280);
}
.approval-context-link {
  min-height: 24px;
  margin: 7px 0;
  font-size: 0.84rem;
}
.approval-link-button {
  border: 0;
  padding: 0;
  color: var(--link-color, #3769d6);
  background: none;
  text-decoration: underline;
  cursor: pointer;
}
/* Origin affordances carry a chat/card title of arbitrary length; keep them
   from forcing the card wider than its container (e.g. the narrow chat dock).
   Buttons default to white-space:nowrap, which otherwise renders a long title
   as one very wide line. */
a.approval-origin-link,
.approval-link-button {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}
.approval-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}
.approval-actions button {
  border-radius: 7px;
  padding: 8px 14px;
  font-weight: 650;
}
.approval-reject {
  border: 1px solid #b94a55;
  color: #b42332;
  background: transparent;
}
.approval-approve {
  border: 1px solid #237947;
  color: white;
  background: #237947;
}
.approval-card-workspace .workspace-approval-card {
  border: none;
  padding: 0;
  margin: 0;
  box-shadow: none;
  background: transparent;
}
.approval-invite-status {
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.9rem;
  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));
}
.approval-invite-status-approved {
  color: var(--success-text);
}
.approval-invite-status-rejected {
  color: var(--danger-text);
  background: var(--danger-bg);
}
@media (max-width: 620px) {
  .approval-card-head {
    flex-direction: column;
    gap: 4px;
  }
  .approval-actions button {
    flex: 1;
  }
}

/* Skill import approval signals */
.skill-import-signals {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.skill-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: var(--surface-2, #eef0f3);
  color: var(--text-2, #333);
  border: 1px solid var(--border-color, #d6dae0);
}
.skill-badge-good {
  background: #e6f4ea;
  color: #1e7e34;
  border-color: #b7dfc2;
}
.skill-badge-warn {
  background: #fdf3e0;
  color: #9a6700;
  border-color: #f0dca8;
}
.skill-badge-bad,
.skill-risk-high {
  background: #fde8e8;
  color: #b02a2a;
  border-color: #f2c2c2;
}
.skill-risk-medium {
  background: #fdf3e0;
  color: #9a6700;
  border-color: #f0dca8;
}
.skill-risk-low {
  background: #e6f4ea;
  color: #1e7e34;
  border-color: #b7dfc2;
}
.skill-import-files code {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/approvals/approvals.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,aAAa;EACb,wCAAwC;EACxC,8BAA8B;EAC9B,6DAA6D;AAC/D;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;EAGE,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;;;2BAG2B;AAC3B;;EAEE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,4DAA4D;AAC9D;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,OAAO;EACT;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB","sourcesContent":[".pending-approvals {\n  margin-bottom: 32px;\n}\n.pending-approvals-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n.pending-approvals-heading h2 {\n  margin: 0 0 3px;\n  font-size: 1.25rem;\n}\n.pending-approvals-heading p {\n  margin: 0;\n}\n.pending-approvals-heading > span {\n  border: 1px solid var(--border-color, #d9d9d9);\n  border-radius: 999px;\n  padding: 3px 9px;\n  font-size: 0.78rem;\n}\n.approval-list {\n  display: grid;\n  gap: 12px;\n}\n.approval-card {\n  border: 1px solid var(--border-color, #d8d8d8);\n  border-radius: var(--radius);\n  padding: 16px;\n  background: var(--card-background, #fff);\n  color: var(--text-color, #111);\n  box-shadow: var(--card-shadow, 0 2px 8px rgba(0, 0, 0, 0.04));\n}\n.approval-card-project {\n  border-left: 4px solid #4f7cff;\n}\n.approval-card-chat {\n  border-left: 4px solid #8b5cf6;\n}\n.approval-card-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n.approval-card-head h3 {\n  margin: 3px 0 0;\n  font-size: 1rem;\n}\n.approval-card-head time {\n  color: var(--secondary-text-color, #6b7280);\n  font-size: 0.78rem;\n  white-space: nowrap;\n}\n.approval-agent {\n  color: var(--secondary-text-color, #6b7280);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\na.approval-agent {\n  color: var(--secondary-text-color, #6b7280);\n  text-decoration: none;\n}\na.approval-agent:hover {\n  text-decoration: underline;\n}\n.approval-requester {\n  color: var(--secondary-text-color, #6b7280);\n  font-size: 0.78rem;\n}\n.approval-on-behalf strong {\n  color: var(--text-color, inherit);\n  font-weight: 600;\n}\n.approval-unattended {\n  font-style: italic;\n}\na.approval-origin-link {\n  color: var(--link-color, #3769d6);\n  text-decoration: underline;\n}\n.approval-reason {\n  margin: 13px 0;\n  padding: 11px 12px;\n  border-radius: var(--radius);\n  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));\n}\n.approval-reason > span {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--secondary-text-color, #6b7280);\n  font-weight: 700;\n}\n.approval-reason p {\n  margin: 5px 0 0;\n  white-space: pre-wrap;\n}\n.approval-invite-person {\n  margin: 13px 0;\n  padding: 11px 12px;\n  border-radius: var(--radius);\n  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));\n}\n.approval-invite-person > span {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--secondary-text-color, #6b7280);\n  font-weight: 700;\n}\n.approval-invite-person p {\n  margin: 5px 0 0;\n  font-weight: 600;\n}\n.approval-inputs {\n  display: grid;\n  gap: 10px;\n  margin: 12px 0;\n}\n.approval-inputs label,\n.approval-note {\n  display: grid;\n  gap: 5px;\n  font-size: 0.83rem;\n  font-weight: 600;\n}\n.approval-inputs input,\n.approval-note select,\n.approval-note textarea {\n  width: 100%;\n  border: 1px solid var(--input-border, #ccc);\n  border-radius: 7px;\n  padding: 9px 10px;\n  color: inherit;\n  background: var(--background-color, transparent);\n}\n.approval-note textarea {\n  min-height: 64px;\n  resize: vertical;\n}\n.approval-note small {\n  font-weight: 400;\n  color: var(--secondary-text-color, #6b7280);\n}\n.approval-context-link {\n  min-height: 24px;\n  margin: 7px 0;\n  font-size: 0.84rem;\n}\n.approval-link-button {\n  border: 0;\n  padding: 0;\n  color: var(--link-color, #3769d6);\n  background: none;\n  text-decoration: underline;\n  cursor: pointer;\n}\n/* Origin affordances carry a chat/card title of arbitrary length; keep them\n   from forcing the card wider than its container (e.g. the narrow chat dock).\n   Buttons default to white-space:nowrap, which otherwise renders a long title\n   as one very wide line. */\na.approval-origin-link,\n.approval-link-button {\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  text-align: left;\n}\n.approval-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 10px;\n}\n.approval-actions button {\n  border-radius: 7px;\n  padding: 8px 14px;\n  font-weight: 650;\n}\n.approval-reject {\n  border: 1px solid #b94a55;\n  color: #b42332;\n  background: transparent;\n}\n.approval-approve {\n  border: 1px solid #237947;\n  color: white;\n  background: #237947;\n}\n.approval-card-workspace .workspace-approval-card {\n  border: none;\n  padding: 0;\n  margin: 0;\n  box-shadow: none;\n  background: transparent;\n}\n.approval-invite-status {\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background: var(--surface-subtle, rgba(127, 127, 127, 0.08));\n}\n.approval-invite-status-approved {\n  color: var(--success-text);\n}\n.approval-invite-status-rejected {\n  color: var(--danger-text);\n  background: var(--danger-bg);\n}\n@media (max-width: 620px) {\n  .approval-card-head {\n    flex-direction: column;\n    gap: 4px;\n  }\n  .approval-actions button {\n    flex: 1;\n  }\n}\n\n/* Skill import approval signals */\n.skill-import-signals {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n.skill-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--surface-2, #eef0f3);\n  color: var(--text-2, #333);\n  border: 1px solid var(--border-color, #d6dae0);\n}\n.skill-badge-good {\n  background: #e6f4ea;\n  color: #1e7e34;\n  border-color: #b7dfc2;\n}\n.skill-badge-warn {\n  background: #fdf3e0;\n  color: #9a6700;\n  border-color: #f0dca8;\n}\n.skill-badge-bad,\n.skill-risk-high {\n  background: #fde8e8;\n  color: #b02a2a;\n  border-color: #f2c2c2;\n}\n.skill-risk-medium {\n  background: #fdf3e0;\n  color: #9a6700;\n  border-color: #f0dca8;\n}\n.skill-risk-low {\n  background: #e6f4ea;\n  color: #1e7e34;\n  border-color: #b7dfc2;\n}\n.skill-import-files code {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
